<!--基本卡片类组件 纯文字卡片 view:12-->
<template>
    <div class="Empty  shadowRadius cardPadding cardWidth">
        <div class="emptyImg">
            <img src="../../assets/img/empty.png" alt="空" class="imgCEmpty">
        </div>
        <div class="tips">
            很抱歉～暂时没有找到你想要的结果
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions, mapMutations} from "vuex";


    export default {
        name: "Empty",
        components: {},
        props: {

            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {};

        },
        mounted() {

        },
        methods: {

            onAsk(name, value) {
                this.$emit("on-ask", name, value);
            }
        }
    };
</script>
<style lang="less" scoped>
    .Empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .emptyImg {
            width: 5rem;
            height: 5rem;

            .imgCEmpty {
                width: 100%;
                max-width: 100%;

            }
        }

        .tips {
            font-size: .4rem;
            color: rgba(178, 191, 203, 1);
        }


    }

</style>
